// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comp-info-edit .comp-info-edit__form .info-form__btns-wrapper {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  margin-top: 20px;\n}\n.comp-info-edit .comp-info-edit__form .info-form__btn--cancel {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
